module.exports = __webpack_public_path__ + "img/icon_map_51_on_001.26944519.png";